export enum OrsServiceExceptionState {
	EMPTY = 1,
	WITHOUT_EXCEPTION = 2,
	WITH_EXCEPTION = 3,
}
